<vs-card *ngIf="claim">
  <vs-card-header [config]="{ title: 'Claim Intake', subtitle: 'Details collected when this claim was reported.' }">
    <button *ngIf="isEditable(claim)" vs-button slot="end" appearance="clear" (click)="dialog.open()">
      <vs-icon name="edit-01"></vs-icon>
    </button>
  </vs-card-header>

  <!-- Same row layout as the Overview card -->
  <ng-template #row let-label="label" let-value="value" let-subtitle="subtitle" let-wrap="wrap">
    <div class="flex gap-2 mx-6 my-4 max-w-full overflow-hidden">
      <div class="basis-1/4">
        <p class="text-sm font-medium text-gray-700 whitespace-nowrap">{{ label }}</p>
      </div>

      <div class="basis-3/4 max-w-[65%] overflow-hidden">
        <p
          class="text-sm font-normal max-w-full overflow-hidden"
          [class.whitespace-pre-line]="wrap"
          [class]="value ? 'text-gray-900' : 'italic text-gray-500'"
        >
          {{ value || 'Not provided' }}
        </p>
        <p *ngIf="value && subtitle" class="text-xs text-gray-500 truncate">{{ subtitle }}</p>
      </div>
    </div>
  </ng-template>

  <ng-container
    *ngTemplateOutlet="row; context: { label: 'Loss date', value: (claim.lossDate | date: 'mediumDate' : 'UTC') }"
  ></ng-container>
  <vs-divider></vs-divider>

  <ng-container
    *ngTemplateOutlet="
      row;
      context: { label: 'Date reported', value: (claim.dateReported | date: 'mediumDate' : 'UTC') }
    "
  ></ng-container>
  <vs-divider></vs-divider>

  <!-- Caller: name with a type badge, contact underneath -->
  <div class="flex gap-2 mx-6 my-4 max-w-full overflow-hidden">
    <div class="basis-1/4">
      <p class="text-sm font-medium text-gray-700 whitespace-nowrap">Caller</p>
    </div>

    <div class="basis-3/4 max-w-[65%] overflow-hidden">
      <ng-container *ngIf="claim.caller as caller; else notProvided">
        <div class="flex items-center gap-2 overflow-hidden">
          <p class="text-sm font-normal text-gray-900 truncate">{{ caller.name }}</p>
          <vs-badge theme="default">{{ callerTypeLabels[caller.type] }}</vs-badge>
        </div>
        <p *ngIf="caller.contact" class="text-xs text-gray-500 truncate">{{ caller.contact }}</p>
      </ng-container>
    </div>
  </div>
  <vs-divider></vs-divider>

  <ng-container
    *ngTemplateOutlet="
      row;
      context: {
        label: 'Service provider',
        value: claim.serviceProviderSnapshot?.name,
        subtitle: claim.serviceProviderSnapshot ? describeProvider(claim.serviceProviderSnapshot) : null,
      }
    "
  ></ng-container>
  <vs-divider></vs-divider>

  <ng-container
    *ngTemplateOutlet="row; context: { label: 'Repair order', value: claim.repairOrderReference }"
  ></ng-container>
  <vs-divider></vs-divider>

  <ng-container
    *ngTemplateOutlet="
      row;
      context: { label: config.repairDeadline.label, value: (claim.repairDeadline | date: 'mediumDate' : 'UTC') }
    "
  ></ng-container>
  <vs-divider></vs-divider>

  <ng-container
    *ngTemplateOutlet="
      row;
      context: {
        label: 'Usage at loss',
        value: claim.usageAtLoss ? (claim.usageAtLoss.value | number) : null,
        subtitle: claim.usageAtLoss
          ? usageTitle((usageDimensions$ | async) ?? [], claim.usageAtLoss.dimensionId)
          : null,
      }
    "
  ></ng-container>
  <vs-divider></vs-divider>

  <ng-container
    *ngTemplateOutlet="row; context: { label: 'Diagnosis', value: claim.diagnosis, wrap: true }"
  ></ng-container>
  <vs-divider></vs-divider>

  <ng-container
    *ngTemplateOutlet="row; context: { label: 'Cause of failure', value: claim.causeOfFailure, wrap: true }"
  ></ng-container>
  <vs-divider></vs-divider>

  <ng-container
    *ngTemplateOutlet="row; context: { label: 'Proposed correction', value: claim.correction, wrap: true }"
  ></ng-container>

  <ng-template #notProvided>
    <p class="text-sm font-normal italic text-gray-500">Not provided</p>
  </ng-template>
</vs-card>

<ws-claim-intake-dialog
  #dialog
  [claim]="claim"
  [usageDimensions]="(usageDimensions$ | async) ?? []"
  (saved)="saved.emit()"
></ws-claim-intake-dialog>
